// eslint-disable-next-line no-unused-vars
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from "react-i18next";
import i18n from "i18next";

const styles = () => ({
	generalPadding: {
		textAlign: "left",
		paddingLeft: ".5rem"
	},
	selectedOptionTextPadding: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		paddingRight: 0
	},
	selectDropListPadding: {
		padding: "0 .5rem"
	},
	selectIcon: {
		fontSize: "1.25em",
		lineHeight: "1.25em",
	},
	errorMessageContainer: {
		minHeight: "1rem",
		fontFamily: 'AIGFutura_Book'
	},
    errorMessage: {
        margin: 0,
        padding: 0,
        fontSize: "1em",
    }
});

interface PassInProperty{
	classes: object,
	t: any,
	selectElementId: string,
	name: string,
	options: Option[],
	label: string,
	icon: string,
	enable: boolean,
	show_arrow: boolean,
	errorMessage: string,
	defaultValue: string,
	onChangeEvent: any
}

interface Option {
	label: {
		"en": string,
		"zh": string,
	},
	value: string,
	disable?: boolean
}

@withTranslation()
@withStyles(styles)
class SelectBox extends React.Component<PassInProperty> {
	
	constructor(props){
		super(props);

		let defaultLabel = "";
		if(typeof this.props.defaultValue === "string") {
			this.props.options.forEach((option: Option) => {
				if(option.value == this.props.defaultValue) {
					defaultLabel = option.label[i18n.language];
				}
			});
		}

		this.state = {
			displayLabel: defaultLabel,
			selectedValue: this.props.defaultValue,
		}
	}

    componentWillReceiveProps = (nextProps) => {
		// When display language changed, update displayLabel based on selectedValue
        if (nextProps.t !== this.props.t) {
        	let updatedLabel = "";
			this.props.options.forEach((option: Option) => {
				if(option.value == this.state.selectedValue) {
					updatedLabel = option.label[i18n.language];
				}
			});
            this.updateDisplayLabel( updatedLabel );
        }

        // When options list updated, update displayLabel
		if (nextProps.options.length !== this.props.options.length && JSON.stringify(nextProps.options) !== JSON.stringify(this.props.options)) {		// use JSON.stringify to compare array of objects deeply
			let defaultLabel = "";
			if(typeof this.props.defaultValue === "string") {
				nextProps.options.forEach((option: Option) => {
					if(option.value == this.props.defaultValue) {
						defaultLabel = option.label[i18n.language];
					}
				});
			}
			this.updateDisplayLabel(defaultLabel);
		}
    };

	updateDisplayLabel = (value) => {
		this.setState({
			displayLabel: value
		})
	};

	updateSelectedValue = (value) => {
		this.setState({
			selectedValue: value
		})
	};

    onSelected = (event) => {
        this.props.onChangeEvent(event.target.value);
        this.updateSelectedValue(event.target.value);

        const index = event.nativeEvent.target.selectedIndex;
        this.updateDisplayLabel(event.nativeEvent.target[index].text);
    };
	
	render(){	
	
	const { 
			classes, 
			t,
			selectElementId,
			name,
			options,
			label,
			icon,		// class name of icon
			enable,
			show_arrow,
			errorMessage,
			onChangeEvent
		} = this.props;

		const has_icon = typeof icon === "string";
					  
		return (
		<>
			<div className="select-box">
				<div className="select-box-wrapper">
					<div className="row no-margin">
						<div className="col-xs col-sm select-box-anchor no-padding">
							<div className="select-box-label">
								<div className="row between-xs no-margin">

									{has_icon &&
										<div className={`col ${classes.generalPadding}`}>
											<i className={`${classes.selectIcon} ${icon}`} aria-hidden="true" />
										</div>
									}

									{label &&
										<div className={`col ${classes.generalPadding}`}>
											<span className="outer">{label}</span>
										</div>
									}

									<div className={`col-xs ${classes.selectedOptionTextPadding}`}>
										<span>{this.state.displayLabel}</span>
									</div>

									{show_arrow &&
										<div className={`col last-xs ${classes.selectDropListPadding}`}>
											<i className="icon-motis-dropdown select-box-arrow" />
										</div>
									}

								</div>
							</div>
							<select
								className="select-box-options"
								id={selectElementId}
								name={name}
                                value={this.state.selectedValue}
								onChange={event => this.onSelected(event)}
								disabled={enable===false}
							>
								{options.map(function(option: Option, i) {
									return <option value={option.value} key={i} disabled={option.disable}>{option.label[i18n.language]}</option>;
								})}
							</select>
						</div>
					</div>
				</div>
				<div className={classes.errorMessageContainer}>
					<label className={`error ${classes.errorMessage}`} htmlFor={selectElementId}>{errorMessage}</label>
				</div>
			</div>
		</>
		);
  	}
}

export default SelectBox;